import gmina_ropczyce_herb from './herby/gmina_ropczyce.png';
import aleksandrow_lodzki_herb from './herby/aleksandrow_lodzki.png';

export const herby = {
  gmina_ropczyce_herb,
  aleksandrow_lodzki_herb,
};



// WEBPACK FOOTER //
// src/components/ServicesHeader/herby.js